import React from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';

const ContentWriters = ({
  contentWriters,
  newContentWriter,
  isEditing,
  formError,
  formSuccess,
  handleInputChange,
  handleContentWriterSubmit,
  handleUpdateWriter,
  handleCancelEdit,
  handleEditWriter,
  handleDeleteWriter
}) => {
  return (
    <div className="p-4">
      <div className="bg-white rounded-lg shadow-md mb-6">
        <div className="p-4 border-b">
          <h2 className="text-xl font-semibold">{isEditing ? 'Edit Content Writer' : 'Create New Content Writer'}</h2>
        </div>
        <div className="p-4">
          {formError && <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">{formError}</div>}
          {formSuccess && <div className="mb-4 p-2 bg-green-100 text-green-700 rounded">{formSuccess}</div>}
          <form onSubmit={isEditing ? handleUpdateWriter : handleContentWriterSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Username</label>
              <input
                type="text"
                name="username"
                value={newContentWriter.username}
                onChange={handleInputChange}
                className="mt-1 block w-full p-2 rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                placeholder="Enter username"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                value={newContentWriter.email}
                onChange={handleInputChange}
                className="mt-1 block w-full p-2 rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                placeholder="Enter email"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {isEditing ? 'New Password (leave blank to keep current)' : 'Password'}
              </label>
              <input
                type="password"
                name="password"
                value={newContentWriter.password}
                onChange={handleInputChange}
                className="mt-1 block w-full p-2 rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                placeholder={isEditing ? "Enter new password" : "Enter password"}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                name="name"
                value={newContentWriter.name}
                onChange={handleInputChange}
                className="mt-1 block w-full p-2 rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                placeholder="Enter full name"
              />
            </div>
            <div className="flex gap-2">
              <button
                type="submit"
                className="flex-1 bg-secondary text-white px-4 py-2 rounded-md hover:bg-secondary/90 transition-colors"
              >
                {isEditing ? 'Update Content Writer' : 'Create Content Writer'}
              </button>
              {isEditing && (
                <button
                  type="button"
                  onClick={handleCancelEdit}
                  className="flex-1 bg-gray-300 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-400 transition-colors"
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md">
        <div className="p-4 border-b">
          <h2 className="text-xl font-semibold">Content Writer Management</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {contentWriters.map((writer) => (
                <tr key={writer._id}>
                  <td className="px-6 py-4 whitespace-nowrap">{writer.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{writer.email}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      writer.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {writer.status || 'inactive'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button 
                      onClick={() => handleEditWriter(writer)}
                      className="text-blue-600 hover:text-blue-800 mr-2"
                    >
                      <FiEdit2 className="w-5 h-5 inline" />
                    </button>
                    <button 
                      onClick={() => handleDeleteWriter(writer._id)}
                      className="text-red-600 hover:text-red-800"
                    >
                      <FiTrash2 className="w-5 h-5 inline" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ContentWriters;
